import { render, staticRenderFns } from "./EditModalFrame.vue?vue&type=template&id=5ab98172&scoped=true&"
import script from "./EditModalFrame.vue?vue&type=script&lang=js&"
export * from "./EditModalFrame.vue?vue&type=script&lang=js&"
import style0 from "./EditModalFrame.vue?vue&type=style&index=0&id=5ab98172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab98172",
  null
  
)

export default component.exports